import { path } from 'ramda'
import { useSelector, shallowEqual } from 'react-redux'

import { Settings, dataKey } from 'app/reducers/settings/warehouseStock'

export { dataKey }

export const useWarehouseStockSettings = () => {
  const settings: Settings = useSelector(path(['settings', dataKey]), shallowEqual)!
  return settings
}
